import { PageHeader } from "../../components/PageHeader";
import { EntityDocumentsSection } from "../../components/EntityDocumentsSection";

// Categorias sugeridas para documentos gerais da empresa (datalist — o utilizador
// pode sempre escrever uma categoria livre).
const GENERAL_DOCUMENT_CATEGORIES = [
  "Comunicações",
  "Seguros",
  "Fiscal / Impostos",
  "Licenças e Certidões",
  "Contratos de Serviços",
  "Consumos (água, luz, gás)",
  "Banca / Financiamento",
  "Recursos Humanos",
  "Outros",
];

// Área "Documentos" — repositório de documentos gerais da empresa que NÃO pertencem
// a nenhuma obra, cliente, fornecedor ou registo financeiro (ex.: faturas da Vodafone,
// apólices de seguro, licenças). Reutiliza o EntityDocumentsSection com o proprietário
// "general" (sem FK) — ver DocumentOwner no backend.
export function DocumentosView() {
  return (
    <div className="flex flex-col h-full">
      <PageHeader
        title="Documentos"
        subtitle="Documentos gerais da empresa que não estão associados a nenhuma obra, cliente ou fornecedor (ex.: faturas de serviços, seguros, licenças)."
      />

      <div className="flex-1 overflow-y-auto p-4 md:p-6">
        <EntityDocumentsSection
          ownerType="general"
          ownerId={0}
          section="general"
          title="Documentos gerais"
          variant="card"
          showCounterparty
          categories={GENERAL_DOCUMENT_CATEGORIES}
          emptyLabel="Ainda não há documentos gerais. Carregue o primeiro (por exemplo, uma fatura da Vodafone, uma apólice de seguro ou uma licença)."
        />
      </div>
    </div>
  );
}
